import { useState } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { InfoMessage } from 'src/core/POS/MessageWithIcon/InfoMessage';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { CrossIcon } from 'src/svgs/Viagogo';
import { IconsFill } from 'src/svgs/Viagogo/enums';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './SearchInfoBanner.css';

export const SearchInfoBanner = ({
  isOnSearchV2,
  onRedirectClick,
}: {
  isOnSearchV2: boolean;
  onRedirectClick: () => void;
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <InfoMessage
      className={styles.searchMessageContainer}
      fill={IconsFill.textInverted}
      message={
        <Stack direction="row" gap="s" alignItems="center">
          <span
            style={{
              whiteSpace: 'nowrap',
              fontSize: vars.typography.fontSize.base,
              fontWeight: 600,
              color: vars.color.textInvertedV2,
            }}
          >
            <Content
              id={
                isOnSearchV2
                  ? ContentId.SearchV2Introduction
                  : ContentId.SearchV2IntroductionOnV1
              }
            />
          </span>
          <Button
            variant="regular"
            onClick={onRedirectClick}
            style={{
              padding: `${vars.spacing.xxs} ${vars.spacing.m}`,
              backgroundColor: vars.color.surfacePrimary,
              color: vars.color.textBrandV2,
            }}
          >
            <div style={{ whiteSpace: 'nowrap' }}>
              <Content
                id={
                  isOnSearchV2
                    ? ContentId.SwitchBackToSearchV1
                    : ContentId.SwitchBackToSearchV2
                }
              />
            </div>
          </Button>
          <CrossIcon
            withHoverEffect
            onClick={() => {
              setIsVisible(false);
            }}
            fill={vars.color.textInvertedV2}
          />
        </Stack>
      }
    />
  );
};
